import React, { memo } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { ListIcon } from '@/icons';
interface QuizSliderHeaderProps {
  currentCount: number;
  maxCount: number;
}
export const QuizSliderHeader = memo(({
  currentCount,
  maxCount
}: QuizSliderHeaderProps) => {
  const {
    t
  } = useTranslation(['build']);
  return <div className="p-md pb-2xs">
        <div className="flex items-center justify-between px-xs pb-3xs pt-4xs">
          <p className="text-body-sm-semibold text-neutral">
            {t('build:build.quiz')}
          </p>

          {/* Count with Icon */}
          <div className="flex items-center gap-3xs">
            <ListIcon size="xs" fill={ICON_COLOR.neutral} />
            <p className="text-body-sm-semibold text-neutral">
              {currentCount} / {maxCount}
            </p>
          </div>
        </div>
      </div>;
});
QuizSliderHeader.displayName = 'QuizSliderHeader';